"use client";

import React from "react";
import Link from "next/link";

interface RelatedTopic {
  label: string;
  url: string;
}

interface RelatedTopicsProps {
  topics: RelatedTopic[];
}

const RelatedTopics: React.FC<RelatedTopicsProps> = ({ topics }) => {
  return (
    <aside
      className="hidden lg:block sticky top-[140px] w-72 h-full bg-gradient-to-b from-white to-gray-50 rounded-lg shadow-md"
      role="navigation"
      aria-label="Related Topics Sidebar"
    >
      <div className="p-2">
        <h3
          className="
            text-2xl font-semibold text-gray-900 mb-2 text-center
            pb-2 after:content-[''] after:block after:w-[100px] after:h-[2px] after:mx-auto
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Related Topics
        </h3>
        <ul className="space-y-0.5">
          {topics.map((topic, idx) => (
            <li key={idx} className="px-2 py-0.5">
              <Link
                href={topic.url}
                className="inline-block text-gray-900 hover:underline hover:text-[#AE7D2F] transition-all duration-300 ease-in-out text-sm"
                aria-label={`Navigate to ${topic.label}`}
              >
                {topic.label}
              </Link>
            </li>
          ))}
        </ul>
        <Link
          href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
          target="_blank"
          rel="noopener noreferrer"
          className="
            block bg-gradient-to-r from-[#AE7D2F] to-[#ECD05B]
            hover:from-[#ECD05B] hover:to-[#AE7D2F]
            text-white font-semibold py-2 px-4 rounded-md
            shadow-md hover:shadow-inner
            [text-shadow:1px_1px_2px_rgba(0,0,0,0.5)]
            hover:scale-105 hover:-translate-y-1
            transition-all duration-300 ease-in-out
            text-center mt-4 mx-auto w-fit
          "
          aria-label="Book an appointment online with Smile4Me Dental Care"
        >
          Book Online Now
        </Link>
      </div>
    </aside>
  );
};

export default RelatedTopics;